export const FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL = "FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL";
export const FIRMWARE_REQUESTS_DETAILS_REQUEST = "FIRMWARE_REQUESTS_DETAILS_REQUEST";
export const FIRMWARE_REQUESTS_DETAILS_RESULT = "FIRMWARE_REQUESTS_DETAILS_RESULT";